/*
The constants defined here are used for the Preview Section layout and components inside them.
This is to ensure any changes to size/colors for the application does not impact the preview section.
*/

export const previewSectionSizes = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '48px',
  '4xl': '72px',
  '5xl': '80px',
  '6xl': '96px',
  '7xl': '112px',
  '8xl': '128px',
  '9xl': '144px',
  '10xl': '160px',
  '12xl': '192px',
  '13xl': '208px',
  '14xl': '224px',
  '15xl': '240px',
  '16xl': '256px',
  '17xl': '272px'
};

export const mobileContainerWidth = previewSectionSizes['15xl'];
export const minimumBannerContainerWidth = '250px';

export const AnimationDuration = 8;

export const DesktopLayoutStyles = {
  height: '464px',
  width: '576px',
  padding: {
    left: previewSectionSizes['3xl'],
    right: previewSectionSizes['3xl']
  }
};

export const minimumUpstreamMessageWidth = previewSectionSizes['15xl'];
